// Models
import { Transaction } from 'models/Transaction'
import { Dedication, CreateDedicationRequestBody } from 'models/Dedication'

// Redux services
import { createDedication } from 'redux/services/dedication'

// Local
import { RootState, TypedDispatch } from 'redux/store'

const getDedicationDetails = (
  dedication: Dedication,
  transaction: Transaction,
): CreateDedicationRequestBody => ({
  transactionId: transaction.id,
  type: dedication.hasDedication ? dedication.type : '',
  honoree_name: dedication.honoreeName,
  name: dedication.recipientName,
  email_address: dedication.recipientEmailAddress,
  address: dedication.recipientAddress,
  city: dedication.recipientCity,
  state: dedication.recipientState,
  postal_code: dedication.recipientPostalCode,
  country: dedication.recipientCountry,
  is_gift_amount_msg_included: dedication.isGiftAmountMessageIncluded,
  first_name: dedication.recipientFirstName,
  last_name: dedication.recipientLastName,
  honoree_first_name: dedication.honoreeFirstName,
  honoree_last_name: dedication.honoreeLastName,
  ecard_id: dedication.selectedEcardId,
  ecard_message: dedication.ecardMessage,
})

const saveDedication = async (
  store: RootState,
  dispatch: TypedDispatch<RootState>,
  transaction: Transaction,
): Promise<void> => {
  await dispatch(
    createDedication.initiate(getDedicationDetails(store.order.dedication, transaction)),
  ).unwrap()
}

export default saveDedication
